import React from 'react';
import firebase from 'firebase/app';


export function usePersonalGuidedMindSweep({ personalGuidedMindSweepKey, uid }) {

  const [error, setError] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState(null);


  React.useEffect(
    () => {
      setLoading(true);
      setError(false);

      const unsubscribe = firebase
        .firestore()
        .collection('personal-guided-mind-sweeps')
        .doc(personalGuidedMindSweepKey)
        .onSnapshot((doc) => {
          const data = doc.data();
          setData({
            key: doc.id,
            exists: doc.exists,
            ...data,
          });
          setLoading(false);
        }, (err) => {
          setError(err);
        });
      return () => unsubscribe();
    },
    [personalGuidedMindSweepKey, uid],
  );

  return {
    error,
    loading,
    data,
  };
}

export function usePersonalGuidedMindSweeps({ uid }) {

  const [error, setError] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState(null);


  React.useEffect(
    () => {
      setLoading(true);
      setError(false);

      const unsubscribe = firebase
        .firestore()
        .collection('personal-guided-mind-sweeps')
        .where('uid', '==', uid)
        .orderBy('updated', 'asc')
        .onSnapshot({ includeMetadataChanges: true }, (snapshot) => {
          const personalGuidedMindSweeps = [];
          snapshot.forEach((doc) => {
            const data = doc.data();
            personalGuidedMindSweeps.unshift({
              key: doc.id,
              ...data,
            });
          });
          setData(personalGuidedMindSweeps);
          setLoading(false);
        }, (err) => {
          console.log(err);
          setError(err);
        });
      return () => unsubscribe();
    },
    [uid],
  );

  return {
    error,
    loading,
    data,
  };
}